// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum ColumnType {
	STATUS = 'status',
	DATE_RANGE = 'date-range',
}

export const UNSCHEDULED_COLUMN_ID = 0;
